// Compiles `style-hover="..."` / `style-focus="..."` attributes into real
// CSS :hover / :focus rules. The original prototype's runtime intercepted
// these attributes and generated scoped pseudo-class rules from them; this
// is the same mechanism, ported directly rather than re-derived, so every
// hover/focus effect in the theme comes from one small utility instead of
// being hand-rebuilt per section (and risking drifting from the original's
// exact values).
//
// The page-load pass only sees markup that exists at DOMContentLoaded —
// content injected later (the Account Hub's JS-rendered panels) must ask
// for compilation itself via window.flixCompileHoverStyles(rootEl), which
// compiles just that subtree. Compiling strips the attribute, so calling
// it again over the same tree is a no-op.
(function () {
  // Hover rules are wrapped in @media (hover:hover) so they never apply on
  // touch screens, where a tap matches :hover and keeps matching it until
  // the next tap lands elsewhere — leaving buttons stuck looking pressed.
  // Focus stays unguarded; it is real on touch too.
  var ATTRS = [['style-hover', ':hover', '@media (hover:hover)'], ['style-focus', ':focus', '']];
  var sheet = null;
  var counter = 0;

  function compileElement(el, attr, pseudo, guard) {
    var css = el.getAttribute(attr);
    if (!css) return;
    if (!sheet) {
      sheet = document.createElement('style');
      sheet.setAttribute('data-flix-hover-sheet', '');
      document.head.appendChild(sheet);
    }
    var cls = 'flx-hov-' + counter++;
    el.classList.add(cls);
    var rule = '.' + cls + pseudo + '{' + css + '}';
    if (guard) rule = guard + '{' + rule + '}';
    sheet.sheet.insertRule(rule, sheet.sheet.cssRules.length);
    el.removeAttribute(attr);
  }

  function compileWithin(root) {
    ATTRS.forEach(function (pair) {
      var attr = pair[0];
      var pseudo = pair[1];
      var guard = pair[2];
      if (root !== document && root.hasAttribute && root.hasAttribute(attr)) {
        compileElement(root, attr, pseudo, guard);
      }
      root.querySelectorAll('[' + attr + ']').forEach(function (el) {
        compileElement(el, attr, pseudo, guard);
      });
    });
  }

  window.flixCompileHoverStyles = compileWithin;

  function init() {
    compileWithin(document);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
